var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-15"},[_c('v-btn',{attrs:{"color":"primary","x-large":""},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._t("default",function(){return [_vm._v("BEWAAR")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }